const state = () => ({
  settings: {
    introTextDutch: "",
    introTextGerman: "",
    helpTextDutch: "",
    helpTextGerman: "",
    globalRateLimiting: 0
  },
  hasModalError: false,
  modalErrorMessage: ""
});

const getters = {};

const actions = {};

const mutations = {
  setSettings(state, val) {
    (state.settings.introTextDutch = val.introTextDutch),
      (state.settings.introTextGerman = val.introTextGerman),
      (state.settings.helpTextDutch = val.helpTextDutch),
      (state.settings.helpTextGerman = val.helpTextGerman),
      (state.settings.globalRateLimiting = val.globalRateLimiting);
  },
  updateIntroTextDutch(state, val) {
    state.settings.introTextDutch = val;
  },
  updateIntroTextGerman(state, val) {
    state.settings.introTextGerman = val;
  },
  updateHelpTextDutch(state, val) {
    state.settings.helpTextDutch = val;
  },
  updateHelpTextGerman(state, val) {
    state.settings.helpTextGerman = val;
  },
  updateGlobalRateLimiting(state, val) {
    state.settings.globalRateLimiting = val;
  },
  enableModalError(state) {
    state.hasModalError = true;
  },
  disableModalError(state) {
    state.hasModalError = false;
    state.modalErrorMessage = "";
  },
  updateModalError(state, message) {
    state.modalErrorMessage = message;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
